export default __webpack_public_path__ + "b8bf5302f9e5a87651aa0744a4269c57.png";